import { createAction, props } from '@ngrx/store';
import { Analysis } from '../models/Analysis';
import { PrintForm } from '../models/PrintForm';
import { Folder } from '../models/Folder';
import { ResponseAnnualReview } from '../models/ResponseAnnualReview';
import { SearchAnalysisParams } from '../models/SearchAnalysisParams';
import { Template } from '../models/Template';
import { Attachment } from '../models/attachment/Attachment';
import { SearchPlantParams } from '../../masterdata/models/SearchPlantParams';
import { SearchTechnologyParams } from '../../masterdata/models/SearchTechnologyParams';
import { SystemError } from 'src/app/shared/models/SystemError';
import { AnalysisPage } from '../models/AnalysisPage';
import { OperatingInstructionsDTO } from '../models/OperatingInstructionsDTO';
import { AnalysisType } from '../models/AnalysisType';
import { AnalysisForm } from '../models/AnalysisForm';
import { LockDataDTO } from '../popups/lock-control-popup/model/LockDataDTO';
import { LockDataResponse } from '../popups/lock-control-popup/model/LockDataResponse';
import { PlantCCDC } from '../../masterdata/models/PlantCCDC';
import { SearchParams } from '../../masterdata/models/SearchParams';
import { UserSimpleSearchParams } from '../../user-admin/user/models/UserSimpleSearchParams';
import { SearchUser } from '../../user-admin/user/models/SearchUser';
import { SingleAnalysis } from '../models/single-analysis/SingleAnalysis';
import { AnalysisCategory } from '../models/AnalysisCategory';
import { UserFavoriteDTO } from '../../user-admin/user/models/UserFavoriteDTO';
import { GroupAnalysisElement } from '../models/group-analysis/GroupAnalysisElement';
import { SupportAba } from '../models/single-analysis/SupportAba';
import { GDMSData } from '../header-data/header-optional-data/header-gdms-popup/models/GDMSData';
import { GDMSProcessData } from '../header-data/header-optional-data/header-gdms-popup/models/GDMSProcessData';
import { GroupAnalysis } from 'src/app/analysis/models/group-analysis/GroupAnalysis';
import { PlannedTvgTimeReport } from '../../print/models/planned-tvg-time-report.model';

export enum ActionTypes {
    GET_ANALYSIS_BY_FUNC_KEY = '[Analysis Page] Loading analysis by func key',
    GET_ANALYSIS_BY_FUNC_KEY_SUCCESS = '[Analysis API] Analysis loaded successfully by func key',
    GET_ANALYSIS_BY_FUNC_KEY_FAIL = '[Analysis API] Analysis failed to load by func key',
    GET_ANALYSIS_BY_ID = '[Analysis Page] Loading analysis by id',
    GET_ANALYSIS_BY_ID_SUCCESS = '[Analysis API] Analysis loaded successfully',
    GET_ANALYSIS_BY_ID_FAIL = '[Analysis API] Analysis failed to load',
    SAVE_ANALYSIS_IN_CACHE = '[Redis cache API] saving analysis in cache',
    SAVE_ANALYSIS_IN_CACHE_SUCCESS = '[Redis cache API] successfully saved analysis to cache',
    SAVE_ANALYSIS_IN_CACHE_FAIL = '[Redis cache API] failed to save analysis to cache',
    SAVE_TEMPLATE_IN_CACHE = '[Redis cache API] saving template in cache',
    SAVE_TEMPLATE_IN_CACHE_SUCCESS = '[Redis cache API] successfully saved template to cache',
    SAVE_TEMPLATE_IN_CACHE_FAIL = '[Redis cache API] failed to save template to cache',
    SET_CR13_ALL_HAZARDS_NO_STRESS = '[Analysis API] Set criterion 13 all hazards noStress to analysis',
    SET_CR13_ALL_HAZARDS_NO_STRESS_FROM_OVERVIEW = '[Analysis API] Set criterion 13 all hazards noStress from overview',
    SET_CR13_ALL_HAZARDS_ONLY_NO_STRESS_VALUE = '[Analysis API] Set criterion 13 all hazards only noStress value to analysis',
    SET_CR13_MAIN_GROUP_NO_STRESS = '[Analysis API] Set criterion 13 hazard noStress to analysis',
    SET_CR13_MAIN_GROUP_ONLY_NO_STRESS_VALUE = '[Analysis API] Set criterion 13 hazard only noStress value to analysis',
    EXPORT_CHANGE_HISTORY = '[Analysis API] Exporting Change History',
    EXPORT_CHANGE_HISTORY_SUCCESS = '[Analysis API] Export Change History successful',
    EXPORT_CHANGE_HISTORY_FAIL = '[Analysis API] Export Change History failed',
    SAVE_SINGLE_ANALYSIS = '[Analysis Page] Saving single analysis',
    SAVE_SINGLE_ANALYSIS_SUCCESS = '[Analysis API] Analysis saved successfully',
    SAVE_SINGLE_ANALYSIS_INCOMPLETE = '[Analysis API] Analysis saved incompleted',
    SAVE_SINGLE_ANALYSIS_FAIL = '[Analysis API] Analysis failed to save',
    SAVE_SINGLE_ANALYSIS_MATERNITY_NO_RECALCULATION = '[Analysis API] Analysis did not save because maternity is not auto recalculated',
    SAVE_SINGLE_ANALYSIS_WITH_MATURITY_OVERRIDEN = '[Analysis API] Analysis save with maternity overriden',
    VALIDATE_SINGLE_ANALYSIS = '[Analysis Page] Validate single analysis',
    VALIDATE_SINGLE_ANALYSIS_SUCCESS = '[Analysis API] Validating single analysis successfully',
    VALIDATE_SINGLE_ANALYSIS_FAIL = '[Analysis API] Validating single analysis failed',
    UPDATE_VALID_FROM_DATE_ON_ANALYSIS_STATE = '[Analysis] Valid From Date updated on Analysis State',
    IS_FAVORITE_SUCCESS = '[Analysis API] Analysis favorite status fetched successfully',
    IS_FAVORITE_FAIL = '[Analysis API] Analysis favorite status fetch failed',
    ADD_TO_FAVORITES = '[Favorites] Add to favorites',
    ADD_TO_FAVORITES_SUCCESS = '[Favorites API] Added to favorites successfully',
    ADD_TO_FAVORITES_FAIL = '[Favorites API] Failed to add to favorites',
    REMOVE_FROM_FAVORITES = '[Favorites] Remove from favorites',
    REMOVE_FROM_FAVORITES_SUCCESS = '[Favorites API] Removed from favorites successfully',
    REMOVE_FROM_FAVORITES_FAIL = '[Favorites API] Failed to remove from favorites',
    PRINT_ANALYSIS = '[Analysis] Print analysis',
    PRINT_ANALYSIS_SUCCESS = '[Analysis API] Analysis print was successfull',
    PRINT_ANALYSIS_FAIL = '[Analysis API] Analysis print failed',
    GET_TEMPLATE_FOLDERS = '[Analysis Template Page] Get all template folders',
    GET_TEMPLATE_FOLDERS_SUCCESS = '[Analysis Template API] Get all template folders success',
    GET_TEMPLATE_FOLDERS_FAIL = '[Analysis Template API] Get all template folders fail',
    UPDATE_ANALYSIS_TEMPLATE = '[Analysis Template Update] Update analysis template',
    SAVE_TEMPLATE = '[Analysis Template Page] Saving analysis template',
    SAVE_TEMPLATE_SUCCESS = '[Analysis Template API] Analysis template saved successfully',
    SAVE_TEMPLATE_FAIL = '[Analysis Template API] Analysis template failed to save',
    RECALC_SINGLE_ANALYSIS = '[Analysis API] Analysis recalculation action',
    RECALC_SINGLE_ANALYSIS_SUCCESS = '[Analysis API] Analysis recalculation was successfull',
    RECALC_SINGLE_ANALYSIS_FAIL = '[Analysis API] Analysis recalculation failed',
    UPDATE_ANALYSIS_ATTACHMENTS = '[Analysis] Update attachments',
    UPDATE_CR_ATTACHMENTS = '[CR - Attachments] Updated CR attachments',
    GET_FILE = '[Analysis] Downloading file',
    GET_FILE_SUCCESS = '[Analysis API] File downloaded successfully',
    GET_FILE_FAIL = '[Analysis API] File failed to download',
    GET_ANALYSIS_HIGEST_VERSION = '[Analysis] Continue in highest version',
    GET_ANALYSIS_HIGEST_VERSION_SUCCESS = '[Analysis API] Get highest version success',
    GET_ANALYSIS_HIGEST_VERSION_FAIL = '[Analysis API] Get highest version fail',
    GET_NEW_ANALYSIS_HIGEST_VERSION = '[Analysis] New highest version',
    GET_NEW_ANALYSIS_HIGEST_VERSION_SUCCESS = '[Analysis API] Get new highest version success',
    GET_NEW_ANALYSIS_HIGEST_VERSION_FAIL = '[Analysis API] Get new highest version fail',
    UPDATE_SELECTED_ANALYSIS_PAGE = '[Analysis] Update the selected analysis page',
    SET_ANALYSIS_TO_CLIPBOARD = '[Analysis] Update the clipboard with all params of the opened analysis',
    SET_ANALYSIS_TO_CLIPBOARD_SUCCESS = '[Analysis API] Success on update the clipboard with all params of the opened analysis',
    SET_ANALYSIS_TO_CLIPBOARD_FAIL = '[Analysis API] Fail on update the clipboard with all params of the opened analysis',
    GET_NEW_ANALYSIS_EMPTY_VERSION = '[Analysis] New empty version',
    GET_NEW_ANALYSIS_EMPTY_VERSION_SUCCESS = '[Analysis API] Get new empty version success',
    GET_NEW_ANALYSIS_EMPTY_VERSION_FAIL = '[Analysis API] Get new empty version fail',
    MARK_AS_ANNUALLY_REVIEWED = '[Analysis API] Mark as Annually Reviewed',
    MARK_AS_ANNUALLY_REVIEWED_SUCCESS = '[Analysis API] Mark as Annually Reviewed success',
    MARK_AS_ANNUALLY_REVIEWED_FAIL = '[Analysis API] Mark as Annually Reviewed fail',
    SET_SINGLE_ANALYSIS_INVALID = '[Analysis] Set single analysis invalid',
    SET_SINGLE_ANALYSIS_INVALID_SUCCESS = '[Analysis API] Set single analysis invalid success',
    SET_SINGLE_ANALYSIS_INVALID_SUCCESS_AND_SAVE_ANALYSIS = '[Analysis API] Set single analysis invalid success and save analysis',
    SET_SINGLE_ANALYSIS_INVALID_FAIL = '[Analysis API] Set single analysis invalid fail',
    VALIDATE_GROUP_ANALYSIS = '[Analysis Page] Validate group analysis',
    VALIDATE_GROUP_ANALYSIS_FAIL = '[Analysis API] Validating group analysis failed',
    SAVE_GROUP_ANALYSIS = '[Analysis Page] Saving group analysis',
    SAVE_GROUP_ANALYSIS_SUCCESS = '[Analysis API] Group Analysis saved successfully',
    SAVE_GROUP_ANALYSIS_INCOMPLETE = '[Analysis API] Group Analysis saved incompleted',
    SAVE_GROUP_ANALYSIS_FAIL = '[Analysis API] Group Analysis failed to save',
    OPEN_GROUP_ANALYSIS_DIALOG_ON_SAVE = '[Analysis Page] Show group analysis validation dialog on save',
    CLOSE_GROUP_ANALYSIS_DIALOG_ON_SAVE = '[Analysis Page] Close group analysis validation dialog on save',
    STOP_SUPPLIER_HANDOVER_PROCESS = '[Analysis API] Stop supplier handover process',
    STOP_SUPPLIER_HANDOVER_PROCESS_SUCCESS = '[Analysis API] Stop supplier handover process success',
    STOP_SUPPLIER_HANDOVER_PROCESS_FAIL = '[Analysis API] Stop supplier handover process fail',
    UPDATE_SHOW_FOOTER_BAR_OVERVIEW_MENU = '[Analysis Page] Update show footer bar overview menu',
    SUPPLIER_HANDOVER = '[Analysis supplier API] Supplier handover analysis to bmw',
    SUPPLIER_HANDOVER_SUCCESS = '[Analysis supplier API] Supplier handover analysis to bmw success',
    SUPPLIER_HANDOVER_FAIL = '[Analysis supplier API] Supplier handover analysis to bmw fail',
    SUPPLIER_CONFIRM = '[Analysis supplier API]  Confirm supplier analysis',
    SUPPLIER_CONFIRM_SUCCESS = '[Analysis supplier API] Confirm supplier analysis success',
    SUPPLIER_CONFIRM_FAIL = '[Analysis supplier API] Confirm supplier analysis fail',
    SUPPLIER_DECLINE = '[Analysis supplier API]  Decline supplier analysis',
    SUPPLIER_DECLINE_SUCCESS = '[Analysis supplier API] Decline supplier analysis success',
    SUPPLIER_DECLINE_FAIL = '[Analysis supplier API] Decline supplier analysis fail',
    LOAD_ANALYSIS_COMPONENT = '[Analysis Page] Load analysis component',
    RECALC_AFTER_NO_STRESS_TOGGLE = '[Analysis API] Recalc after no stress toggle',
    COPY_URL_TO_CLIPBOARD_MAX_VALID_VERSION = "[Analysis] Copying URL of current analysis' highest valid version to clipboard",
    COPY_URL_TO_CLIPBOARD_MAX_VALID_VERSION_SUCCESS = "[Analysis] Copied URL of current analysis' highest valid version to clipboard successfully",
    VALIDATE_SPECIFIC_DATA_MM = '[Analysis API] Validate specific analysis criterion data',
    VALIDATE_DATA_MM = '[Analysis API] Validate analysis criterion data',
    VALIDATE_DATA_MM_SUCCESS = '[Analysis API] Validate analysis criterion data success',
    VALIDATE_DATA_MM_FAIL = '[Analysis API] Validate analysis criterion data fail',
    DELETE_FILE = '[Analysis] Deleting file',
    DELETE_FILE_SUCCESS = '[Analysis API] File deleted successfully',
    DELETE_FILE_FAIL = '[Analysis API] File failed to delete',
    CREATE_ANALYSIS_FROM_TMO_PREVIEW = '[Analysis API] Create analysis from tmo preview',
    CREATE_ANALYSIS_FROM_TMO_PREVIEW_SUCCESS = '[Analysis API] Create analysis from tmo preview success',
    CREATE_ANALYSIS_FROM_TMO_PREVIEW_FAIL = '[Analysis API] Create analysis from tmo preview fail',
    RECALC_SINGLE_ANALYSIS_AND_SHOW_TOAST_ON_SUCCESS = '[Analysis API] Recalculate single analysis and show toast on success',
    UPDATE_FORCE_CASE_ATTACHMENTS = '[Criterions Page] Update force case attachments on a given DataMM state',
    GET_NEW_VERSION_FROM_CLIPBOARD = '[Analysis] Get new version from clipboard',
    GET_NEW_VERSION_FROM_CLIPBOARD_SUCCESS = '[Analysis] Get new version from clipboard success',
    GET_NEW_VERSION_FROM_CLIPBOARD_FAIL = '[Analysis] Get new version from clipboard fail',
    GET_CLIPBOARD_SUCCESS = '[Analysis] Get clipboard success',
    GET_CLIPBOARD_FAIL = '[Analysis] Get clipboard fail',
    PASTE_FROM_CLIPBOARD = '[Analysis] Paste from clipboard',
    PASTE_FROM_CLIPBOARD_SUCCESS = '[Analysis] Paste from clipboard success',
    PASTE_FROM_CLIPBOARD_FAIL = '[Analysis] Paste from clipboard fail',
    INSERT_FROM_TEMPLATE = '[Analysis Page] Insert from template',
    SCHEDULE_OPEN_OPERATING_INSTRUCTIONS = '[Analysis Page] Schedule open operating instructions popup',
    OPEN_OPERATING_INSTRUCTIONS = '[Analysis Page] Open operating instructions popup',
    CLOSE_OPERATING_INSTRUCTIONS = '[Analysis Page] Close operating instructions popup',
    PRINT_OPERATING_INSTRUCTIONS_DOCUMENT = '[Analysis Page] Print operating instructions document',
    PRINT_OPERATING_INSTRUCTIONS_DOCUMENT_SUCCESS = '[Analysis API] operating instructions document print was successfull',
    PRINT_OPERATING_INSTRUCTIONS_DOCUMENT_FAIL = '[Analysis API] operating instructions document print failed',
    SET_TRAINING_VALIDATION = '[Analysis Page] Set training analysis validation flag true',
    SET_TRAINING_ANALYSIS_VALID = '[Analysis API] Set training analysis valid',
    SET_TRAINING_ANALYSIS_VALID_SUCCESS = '[Analysis API] Setting training analysis valid was successfull',
    SET_TRAINING_ANALYSIS_VALID_FAIL = '[Analysis API] Setting training analysis valid failed',
    UPDATE_ANALYSIS_PARTIAL = '[Analysis Page] Update analysis partial',
    UPDATE_SINGLE_ANALYSIS_PARTIAL = '[Analysis Page] Update single analysis partial',
    UPDATE_GROUP_ANALYSIS_PARTIAL = '[Analysis Page] Update group analysis partial',
    UPDATE_ANALYSIS_PARTIAL_RECALC = '[Analysis Page] Update analysis partial with recalc',
    UPDATE_SINGLE_ANALYSIS_PARTIAL_RECALC = '[Analysis Page] Update single analysis partial with recalc',
    GET_ANALYSIS_TYPES_AND_FORMS = '[Analysis Page] Get analysis types and forms',
    GET_ANALYSIS_TYPES_SUCCESS = '[Analysis API] Get analysis types success',
    GET_ANALYSIS_TYPES_FAIL = '[Analysis API] Get analysis types fail',
    GET_ANALYSIS_FORMS_SUCCESS = '[Analysis API] Get analysis forms success',
    GET_ANALYSIS_FORMS_FAIL = '[Analysis API] Get analysis forms fail',
    GET_FAVORITES_BY_USER = '[User Favorites] Get favorites by user',
    GET_FAVORITES_BY_USER_SUCCESS = '[User Favorites API] Get favorites by user success',
    GET_FAVORITES_BY_USER_FAIL = '[User Favorites API] Get favorites by user fail',
    ADD_FAVORITE_USER = '[User Favorites] Add favorite user',
    ADD_FAVORITE_USER_SUCCESS = '[User Favorites API] Add favorite user success',
    ADD_FAVORITE_USER_FAIL = '[User Favorites API] Add favorite user fail',
    REMOVE_FAVORITE_USER = '[User Favorites] Remove favorite user',
    REMOVE_FAVORITE_USER_SUCCESS = '[User Favorites API] Remove favorite user success',
    REMOVE_FAVORITE_USER_FAIL = '[User Favorites API] Remove favorite user fail',
    SEARCH_USER = '[User Search] Search user',
    SEARCH_USER_SUCCESS = '[User Search API] Search user success',
    SEARCH_USER_FAIL = '[User Search API] Search user fail',
    CLEAR_SEARCH_USER_PARAMS = '[User Search API] Clear search user params',
    EXIT_PREVIEW_MODE = '[Analysis Page] Exit preview mode',
    UPDATE_GROUP_ANALYSIS_ELEMENTS = '[Analysis] Update group analysis elements',
    RECALC_GROUP_ANALYSIS = '[Analysis API] Analysis recalculation action for group analysis',
    RECALC_GROUP_ANALYSIS_SUCCESS = '[Analysis API] Group Analysis recalculation was successfull',
    RECALC_GROUP_ANALYSIS_FAIL = '[Analysis API] Group Analysis recalculation failed',
    CREATE_EMPTY_ANALYSIS = '[Analysis Page] Creating new empty analysis',
    CREATE_EMPTY_ANALYSIS_SUCCESS = '[Analysis API] New empty analysis created successfully',
    CREATE_EMPTY_ANALYSIS_FAIL = '[Analysis API] Failed to create new empty analysis',
    LOAD_GDMS_POPUP_DATA = '[Analysis Page] Load GDMS data popup',
    LOAD_GDMS_POPUP_DATA_SUCCESS = '[Analysis Page] Load GDMS data popup success',
    LOAD_GDMS_POPUP_DATA_FAIL = '[Analysis Page] Load GDMS data popup fail',
    SAVE_ANALYSIS_AND_START_GDMS_APPROVAL_PROCESS = '[Analysis Page] Save analysis and start GDMS approval process',
    START_GDMS_APPROVAL_PROCESS_AFTER_SAVE = '[Analysis Page] Start GDMS approval process after save',
    SAVE_ANALYSIS_AND_START_GDMS_APPROVAL_PROCESS_SUCCESS = '[Analysis Page] Save analysis and start GDMS approval process success',
    SAVE_ANALYSIS_AND_START_GDMS_APPROVAL_PROCESS_FAIL = '[Analysis Page] Save analysis and start GDMS approval process fail',
    STOP_GDMS_PROCESS = '[Analysis Page] Stop GDMS process',
    STOP_GDMS_PROCESS_SUCCESS = '[Analysis Page] Stop GDMS process success',
    STOP_GDMS_PROCESS_FAIL = '[Analysis Page] Stop GDMS process fail',
    LOAD_GDMS_DOCUMENT_URL = '[Analysis Page] Load GDMS document URL',
    LOAD_GDMS_DOCUMENT_URL_SUCCESS = '[Analysis Page] Loaded GDMS document URL successfully',
    LOAD_GDMS_DOCUMENT_URL_FAIL = '[Analysis Page] Failed to load GDMS document URL',
    START_CONNECT_ANALYSIS = '[Analysis Page] Start the connect analysis process',
    START_CONNECT_ANALYSES_PROCESS = '[Analysis Page] Start the connect analyses process',
    VALIDATE_NOT_NULL_SUCCESS = '[Analysis API] Validate analysis not null success',
    VALIDATE_NOT_NULL_FAIL = '[Analysis API] Validate analysis not null fail',
    CREATE_GROUP_ANALYSIS_ELEMENTS = '[Analysis] Create group analysis elements',
    CREATE_GROUP_ANALYSIS_ELEMENTS_SUCCESS = '[Analysis API] Create group analysis elements success',
    CREATE_GROUP_ANALYSIS_ELEMENTS_FAIL = '[Analysis API] Create group analysis elements fail',
    UPDATE_CONNECTIONS = '[Analysis] Update connections for support analyses',
    UPDATE_CONNECTIONS_SUCCESS = '[Analysis API] Update connections for support analyses success',
    UPDATE_CONNECTIONS_FAIL = '[Analysis API] Update connections for support analyses fail',
    UPDATE_SUPPORT_ANALYSIS = '[Analysis] Update support analyses',
    IS_LOCKED_SUCCESS = '[Analysis API] Analysis locked status fetched successfully',
    IS_LOCKED_FAIL = '[Analysis API] Analysis locked status fetch failed',
    SAVE_LOCK_DATA = '[Analysis API] Save lock data',
    SAVE_LOCK_DATA_SUCCESS = '[Analysis API] Save lock data success',
    SAVE_LOCK_DATA_FAIL = '[Analysis API] Save lock data fail',
    LOAD_LOCK_DATA = '[Analysis API] Load lock data',
    LOAD_LOCK_DATA_SUCCESS = '[Analysis API] Load lock data success',
    LOAD_LOCK_DATA_FAIL = '[Analysis API] Load lock data fail',
    LOAD_LOCK_CCDC_LIST = '[Analysis API] Load lock CCDC list',
    LOAD_LOCK_CCDC_LIST_SUCCESS = '[Analysis API] Load lock CCDC list success',
    LOAD_LOCK_CCDC_LIST_FAIL = '[Analysis API] Load lock CCDC list fail',
    CLEAR_LOCK_CCDC_LIST = '[Analysis API] Clear lock CCDC list',
    OPEN_LOCK_CONTROL_POPUP = '[Analysis Page] Open lock control popup',
    RESET_ANALYSIS_STATE = '[Analysis] Reset state',
    LOAD_SEARCH_COMPONENT = '[Analysis Page] Load search component',
    GENERATE_QR_CODE_PDF = '[Analysis Page] Generate QR Code PDF',
    GENERATE_QR_CODE_PDF_SUCCESS = '[Analysis API] Generate QR Code PDF success',
    GENERATE_QR_CODE_PDF_FAIL = '[Analysis API] Generate QR Code PDF fail',
    RESET_QR_CODE_PDF_URL = '[Analysis] Reset QR Code PDF URL',
    DELETE_ANALYSIS = '[Analysis Page] Delete analysis',
    DELETE_ANALYSIS_SUCCESS = '[Analysis API] Delete analysis success',
    DELETE_ANALYSIS_FAIL = '[Analysis API] Delete analysis fail',
    ARCHIVE_ANALYSIS_MANUALLY = '[Analysis Page] Archive analysis manually',
    ARCHIVE_ANALYSIS_MANUALLY_SUCCESS = '[Analysis API] Archive analysis manually success',
    ARCHIVE_ANALYSIS_MANUALLY_FAIL = '[Analysis API] Archive analysis manually fail',
    PRINT_PLANNED_TVG_TIME = '[Analysis Page] Print planned TVG time',
    PRINT_PLANNED_TVG_TIME_SUCCESS = '[Analysis API] Planned TVG time print was successful',
    PRINT_PLANNED_TVG_TIME_FAIL = '[Analysis API] Planned TVG time print failed',
    LOAD_PLANNED_TVG_TIME_REPORT = '[Analysis Page] Load planned TVG time report',
    LOAD_PLANNED_TVG_TIME_REPORT_SUCCESS = '[Analysis API] Planned TVG time report loaded successfully',
    LOAD_PLANNED_TVG_TIME_REPORT_FAIL = '[Analysis API] Planned TVG time report load failed',
    OPEN_LEAVE_ANALYSIS_CONFIRMATION = '[Analysis Page] Open leave analysis without saving confirmation',
    CONFIRM_LEAVE_ANALYSIS = '[Analysis Page] Confirm leave analysis without saving',
    CANCEL_LEAVE_ANALYSIS = '[Analysis Page] Cancel leave analysis without saving',
    REQUEST_ANALYSIS_VERSION = '[Analysis Page] Request analysis version'
}

export const getAnalysisByFuncKey = createAction(
    ActionTypes.GET_ANALYSIS_BY_FUNC_KEY,
    props<{ searchAnalysisParams: SearchAnalysisParams; isFromSwitchVersion: boolean }>()
);

export const getAnalysisByFuncKeySuccess = createAction(
    ActionTypes.GET_ANALYSIS_BY_FUNC_KEY_SUCCESS,
    props<{ analysis: Analysis | null; isFromSwitchVersion: boolean }>()
);

export const getAnalysisByFuncKeyFail = createAction(ActionTypes.GET_ANALYSIS_BY_FUNC_KEY_FAIL, props<{ systemError: SystemError }>());

export const getAnalysisById = createAction(ActionTypes.GET_ANALYSIS_BY_ID, props<{ id: number }>());

export const getAnalysisByIdSuccess = createAction(ActionTypes.GET_ANALYSIS_BY_ID_SUCCESS, props<{ analysis: Analysis }>());

export const getAnalysisByIdFail = createAction(ActionTypes.GET_ANALYSIS_BY_ID_FAIL, props<{ systemError: SystemError }>());

export const getAnalysisHighestVersion = createAction(ActionTypes.GET_ANALYSIS_HIGEST_VERSION);

export const getAnalysisHighestVersionSuccess = createAction(ActionTypes.GET_ANALYSIS_HIGEST_VERSION_SUCCESS, props<{ analysis: Analysis }>());

export const getAnalysisHighestVersionFail = createAction(ActionTypes.GET_ANALYSIS_HIGEST_VERSION_FAIL, props<{ systemError: SystemError }>());

export const getNewAnalysisHighestVersion = createAction(ActionTypes.GET_NEW_ANALYSIS_HIGEST_VERSION);

export const getNewAnalysisHighestVersionSuccess = createAction(ActionTypes.GET_NEW_ANALYSIS_HIGEST_VERSION_SUCCESS, props<{ analysis: Analysis }>());

export const getNewAnalysisHighestVersionFail = createAction(ActionTypes.GET_NEW_ANALYSIS_HIGEST_VERSION_FAIL, props<{ systemError: SystemError }>());

export const saveAnalysisInCacheAndRouteTo = createAction(
    ActionTypes.SAVE_ANALYSIS_IN_CACHE,
    props<{ redirectUrl: string; isAbsoluteUrl?: boolean; newPage?: boolean }>()
);

export const saveAnalysisInCacheSuccess = createAction(
    ActionTypes.SAVE_ANALYSIS_IN_CACHE_SUCCESS,
    props<{ redirectUrl: string; isAbsoluteUrl: boolean; newPage: boolean; analysisKey: string; version: number }>()
);

export const saveAnalysisInCacheFail = createAction(ActionTypes.SAVE_ANALYSIS_IN_CACHE_FAIL, props<{ systemError: SystemError }>());

export const saveTemplateInCacheAndRouteTo = createAction(ActionTypes.SAVE_TEMPLATE_IN_CACHE, props<{ redirectUrl: string }>());

export const saveTemplateInCacheSuccess = createAction(ActionTypes.SAVE_TEMPLATE_IN_CACHE_SUCCESS, props<{ redirectUrl: string; analysisId: number | null }>());

export const saveTemplateInCacheFail = createAction(ActionTypes.SAVE_TEMPLATE_IN_CACHE_FAIL, props<{ systemError: SystemError }>());

export const setCr13AllHazardsNoStress = createAction(ActionTypes.SET_CR13_ALL_HAZARDS_NO_STRESS, props<{ noStress: boolean }>());

export const setCr13AllHazardsNoStressFromOverview = createAction(ActionTypes.SET_CR13_ALL_HAZARDS_NO_STRESS_FROM_OVERVIEW, props<{ noStress: boolean }>());

export const setCr13AllHazardsOnlyNoStressValue = createAction(ActionTypes.SET_CR13_ALL_HAZARDS_ONLY_NO_STRESS_VALUE, props<{ noStress: boolean }>());

export const recalcAfterNoStressToggle = createAction(ActionTypes.RECALC_AFTER_NO_STRESS_TOGGLE, props<{ noStress: boolean }>());

export const setCr13MainGroupNoStress = createAction(
    ActionTypes.SET_CR13_MAIN_GROUP_NO_STRESS,
    props<{ mainGroupDefMM13Id: number; noStress: boolean; subGroupsDefMM13Ids: number[] }>()
);

export const setCr13MainGroupOnlyNoStressValue = createAction(
    ActionTypes.SET_CR13_MAIN_GROUP_ONLY_NO_STRESS_VALUE,
    props<{ mainGroupDefMM13Id: number; noStress: boolean }>()
);

export const exportChangeHistory = createAction(ActionTypes.EXPORT_CHANGE_HISTORY);

export const exportChangeHistorySuccess = createAction(ActionTypes.EXPORT_CHANGE_HISTORY_SUCCESS);

export const exportChangeHistoryFail = createAction(ActionTypes.EXPORT_CHANGE_HISTORY_FAIL, props<{ systemError: SystemError }>());

export const saveSingleAnalysis = createAction(ActionTypes.SAVE_SINGLE_ANALYSIS);

export const saveSingleAnalysisSuccess = createAction(ActionTypes.SAVE_SINGLE_ANALYSIS_SUCCESS, props<{ analysis: Analysis; message: string }>());

export const saveSingleAnalysisIncomplete = createAction(ActionTypes.SAVE_SINGLE_ANALYSIS_INCOMPLETE, props<{ analysis: Analysis; message: string }>());

export const saveSingleAnalysisFail = createAction(ActionTypes.SAVE_SINGLE_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const saveSingleAnalysisMaternityFailNoAutoCalculation = createAction(ActionTypes.SAVE_SINGLE_ANALYSIS_MATERNITY_NO_RECALCULATION);

export const saveSingleAnalysisWithMaturityOverriden = createAction(
    ActionTypes.SAVE_SINGLE_ANALYSIS_WITH_MATURITY_OVERRIDEN,
    props<{ isKeptOverriden: boolean }>()
);

export const validateSingleAnalysis = createAction(ActionTypes.VALIDATE_SINGLE_ANALYSIS);

export const validateSingleAnalysisSuccess = createAction(ActionTypes.VALIDATE_SINGLE_ANALYSIS_SUCCESS);

export const validateSingleAnalysisFail = createAction(ActionTypes.VALIDATE_SINGLE_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const updateValidFromDateOnAnalysisState = createAction(ActionTypes.UPDATE_VALID_FROM_DATE_ON_ANALYSIS_STATE, props<{ validFrom: Date }>());

export const isFavoriteSuccess = createAction(ActionTypes.IS_FAVORITE_SUCCESS, props<{ isFavorite: boolean }>());

export const isFavoriteFail = createAction(ActionTypes.IS_FAVORITE_FAIL, props<{ systemError: SystemError }>());

export const addToFavorites = createAction(ActionTypes.ADD_TO_FAVORITES);

export const addToFavoritesSuccess = createAction(ActionTypes.ADD_TO_FAVORITES_SUCCESS, props<{ message: string }>());

export const addToFavoritesFail = createAction(ActionTypes.ADD_TO_FAVORITES_FAIL, props<{ systemError: SystemError }>());

export const removeFromFavorites = createAction(ActionTypes.REMOVE_FROM_FAVORITES);

export const removeFromFavoritesSuccess = createAction(ActionTypes.REMOVE_FROM_FAVORITES_SUCCESS);

export const removeFromFavoritesFail = createAction(ActionTypes.REMOVE_FROM_FAVORITES_FAIL, props<{ systemError: SystemError }>());

export const printAnalysis = createAction(ActionTypes.PRINT_ANALYSIS, props<{ print: PrintForm }>());

export const printAnalysisSuccess = createAction(ActionTypes.PRINT_ANALYSIS_SUCCESS, props<{ message: string }>());

export const printAnalysisFail = createAction(ActionTypes.PRINT_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const getTemplateFolders = createAction(ActionTypes.GET_TEMPLATE_FOLDERS);

export const getTemplateFoldersSuccess = createAction(ActionTypes.GET_TEMPLATE_FOLDERS_SUCCESS, props<{ templateFolders: Folder[] }>());

export const getTemplateFoldersFail = createAction(ActionTypes.GET_TEMPLATE_FOLDERS_FAIL, props<{ systemError: SystemError }>());

export const updateAnalysisTemplate = createAction(ActionTypes.UPDATE_ANALYSIS_TEMPLATE, props<{ template: Template }>());

export const saveTemplate = createAction(ActionTypes.SAVE_TEMPLATE);

export const saveTemplateSuccess = createAction(ActionTypes.SAVE_TEMPLATE_SUCCESS);

export const saveTemplateFail = createAction(ActionTypes.SAVE_TEMPLATE_FAIL, props<{ systemError: SystemError }>());

export const recalcSingleAnalysis = createAction(ActionTypes.RECALC_SINGLE_ANALYSIS);

export const recalcSingleAnalysisSuccess = createAction(ActionTypes.RECALC_SINGLE_ANALYSIS_SUCCESS, props<{ analysis: Analysis }>());

export const recalcSingleAnalysisFail = createAction(ActionTypes.RECALC_SINGLE_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const recalcGroupAnalysis = createAction(ActionTypes.RECALC_GROUP_ANALYSIS);

export const recalcGroupAnalysisSuccess = createAction(ActionTypes.RECALC_GROUP_ANALYSIS_SUCCESS, props<{ analysis: Analysis }>());

export const recalcGroupAnalysisFail = createAction(ActionTypes.RECALC_GROUP_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const getFile = createAction(ActionTypes.GET_FILE, props<{ pathContext: string; filename: string }>());

export const getFileSuccess = createAction(ActionTypes.GET_FILE_SUCCESS);

export const getFileFail = createAction(ActionTypes.GET_FILE_FAIL, props<{ systemError: SystemError }>());

export const updateAnalysisAttachments = createAction(ActionTypes.UPDATE_ANALYSIS_ATTACHMENTS, props<{ analysisAttachments: Attachment[] }>());

export const updateForceCaseAttachments = createAction(ActionTypes.UPDATE_FORCE_CASE_ATTACHMENTS, props<{ attachments: any[]; criterionToChange: string }>());

export const updateCrAttachments = createAction(ActionTypes.UPDATE_CR_ATTACHMENTS, props<{ attachments: Attachment[]; criterionToChange: string }>());

export const updateSelectedAnalysisPage = createAction(ActionTypes.UPDATE_SELECTED_ANALYSIS_PAGE, props<{ selectedAnalysisPage: AnalysisPage | null }>());

export const setAnalysisToClipboard = createAction(ActionTypes.SET_ANALYSIS_TO_CLIPBOARD);

export const setAnalysisToClipboardSuccess = createAction(ActionTypes.SET_ANALYSIS_TO_CLIPBOARD_SUCCESS, props<{ message: string }>());

export const setAnalysisToClipboardFail = createAction(ActionTypes.SET_ANALYSIS_TO_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const getNewAnalysisEmptyVersion = createAction(ActionTypes.GET_NEW_ANALYSIS_EMPTY_VERSION);

export const getNewAnalysisEmptyVersionSuccess = createAction(ActionTypes.GET_NEW_ANALYSIS_EMPTY_VERSION_SUCCESS, props<{ analysis: Analysis }>());

export const getNewAnalysisEmptyVersionFail = createAction(ActionTypes.GET_NEW_ANALYSIS_EMPTY_VERSION_FAIL, props<{ systemError: SystemError }>());

export const markAsAnnuallyReviewed = createAction(ActionTypes.MARK_AS_ANNUALLY_REVIEWED);

export const markAsAnnuallyReviewedSuccess = createAction(
    ActionTypes.MARK_AS_ANNUALLY_REVIEWED_SUCCESS,
    props<{ responseAnnualReview: ResponseAnnualReview; message: string }>()
);

export const markAsAnnuallyReviewedFail = createAction(ActionTypes.MARK_AS_ANNUALLY_REVIEWED_FAIL, props<{ systemError: SystemError }>());

export const setSingleAnalysisInvalid = createAction(ActionTypes.SET_SINGLE_ANALYSIS_INVALID, props<{ validTo: Date }>());

export const setSingleAnalysisInvalidSuccess = createAction(ActionTypes.SET_SINGLE_ANALYSIS_INVALID_SUCCESS, props<{ analysis: Analysis; message: string }>());

export const setSingleAnalysisInvalidSuccessAndSaveAnalysis = createAction(
    ActionTypes.SET_SINGLE_ANALYSIS_INVALID_SUCCESS_AND_SAVE_ANALYSIS,
    props<{ analysis: Analysis; message: string }>()
);

export const setSingleAnalysisInvalidFail = createAction(ActionTypes.SET_SINGLE_ANALYSIS_INVALID_FAIL, props<{ systemError: SystemError }>());
export const saveGroupAnalysis = createAction(ActionTypes.SAVE_GROUP_ANALYSIS);

export const saveGroupAnalysisSuccess = createAction(ActionTypes.SAVE_GROUP_ANALYSIS_SUCCESS, props<{ analysis: Analysis; message: string }>());

export const saveGroupAnalysisIncomplete = createAction(ActionTypes.SAVE_GROUP_ANALYSIS_INCOMPLETE, props<{ analysis: Analysis; message: string }>());

export const saveGroupAnalysisFail = createAction(ActionTypes.SAVE_GROUP_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const validateGroupAnalysis = createAction(ActionTypes.VALIDATE_GROUP_ANALYSIS);

export const validateGroupAnalysisFail = createAction(ActionTypes.VALIDATE_GROUP_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const openGroupAnalysisDialogOnSave = createAction(ActionTypes.OPEN_GROUP_ANALYSIS_DIALOG_ON_SAVE);

export const closeGroupAnalysisDialogOnSave = createAction(ActionTypes.CLOSE_GROUP_ANALYSIS_DIALOG_ON_SAVE);

export const openLeaveAnalysisConfirmation = createAction(ActionTypes.OPEN_LEAVE_ANALYSIS_CONFIRMATION);

export const confirmLeaveAnalysis = createAction(ActionTypes.CONFIRM_LEAVE_ANALYSIS);

export const cancelLeaveAnalysis = createAction(ActionTypes.CANCEL_LEAVE_ANALYSIS);

export const stopSupplierHandoverProcess = createAction(ActionTypes.STOP_SUPPLIER_HANDOVER_PROCESS, props<{ analysisId: number; isFromWorkstock: boolean }>());

export const stopSupplierHandoverProcessSuccess = createAction(ActionTypes.STOP_SUPPLIER_HANDOVER_PROCESS_SUCCESS);

export const stopSupplierHandoverProcessFail = createAction(ActionTypes.STOP_SUPPLIER_HANDOVER_PROCESS_FAIL, props<{ systemError: SystemError }>());

export const updateShowFooterBarOverviewMenu = createAction(ActionTypes.UPDATE_SHOW_FOOTER_BAR_OVERVIEW_MENU);

export const supplierHandover = createAction(ActionTypes.SUPPLIER_HANDOVER);

export const supplierHandoverSuccess = createAction(ActionTypes.SUPPLIER_HANDOVER_SUCCESS, props<{ analysis: Analysis; message: string }>());

export const supplierHandoverFail = createAction(ActionTypes.SUPPLIER_HANDOVER_FAIL, props<{ systemError: SystemError }>());

export const supplierConfirm = createAction(ActionTypes.SUPPLIER_CONFIRM);

export const supplierConfirmSuccess = createAction(ActionTypes.SUPPLIER_CONFIRM_SUCCESS, props<{ analysis: Analysis }>());

export const supplierConfirmFail = createAction(ActionTypes.SUPPLIER_CONFIRM_FAIL, props<{ systemError: SystemError }>());

export const supplierDecline = createAction(ActionTypes.SUPPLIER_DECLINE);

export const supplierDeclineSuccess = createAction(ActionTypes.SUPPLIER_DECLINE_SUCCESS, props<{ analysis: Analysis }>());

export const supplierDeclineFail = createAction(ActionTypes.SUPPLIER_DECLINE_FAIL, props<{ systemError: SystemError }>());

export const loadAnalysisComponent = createAction(
    ActionTypes.LOAD_ANALYSIS_COMPONENT,
    props<{ searchPlantParams: SearchPlantParams; searchTechnologyParams: SearchTechnologyParams }>()
);
export const copyUrlToClipboardMaxValidVersion = createAction(ActionTypes.COPY_URL_TO_CLIPBOARD_MAX_VALID_VERSION, props<{ url: string }>());

export const copyUrlToClipboardMaxValidVersionSuccess = createAction(ActionTypes.COPY_URL_TO_CLIPBOARD_MAX_VALID_VERSION_SUCCESS, props<{ message: string }>());

export const validateDataMM = createAction(ActionTypes.VALIDATE_DATA_MM, props<{ afterFn: () => void }>());

export const validateSpecificDataMM = createAction(ActionTypes.VALIDATE_SPECIFIC_DATA_MM, props<{ criterion: string; afterFn: () => void }>());

export const validateDataMMSuccess = createAction(ActionTypes.VALIDATE_DATA_MM_SUCCESS, props<{ afterFn: () => void }>());

export const validateDataMMFail = createAction(ActionTypes.VALIDATE_DATA_MM_FAIL, props<{ systemError: SystemError }>());

export const deleteFile = createAction(ActionTypes.DELETE_FILE, props<{ fileId: string }>());

export const deleteFileSuccess = createAction(ActionTypes.DELETE_FILE_SUCCESS);

export const deleteFileFail = createAction(ActionTypes.DELETE_FILE_FAIL, props<{ systemError: SystemError }>());

export const createAnalysisFromTMOPreview = createAction(ActionTypes.CREATE_ANALYSIS_FROM_TMO_PREVIEW, props<{ validFromTomorrow: boolean }>());

export const createAnalysisFromTMOPreviewSuccess = createAction(
    ActionTypes.CREATE_ANALYSIS_FROM_TMO_PREVIEW_SUCCESS,
    props<{ analysisKey: string; version: number }>()
);

export const createAnalysisFromTMOPreviewFail = createAction(ActionTypes.CREATE_ANALYSIS_FROM_TMO_PREVIEW_FAIL, props<{ systemError: SystemError }>());

export const recalcSingleAnalysisAndShowToastOnSuccess = createAction(
    ActionTypes.RECALC_SINGLE_ANALYSIS_AND_SHOW_TOAST_ON_SUCCESS,
    props<{ analysis: Analysis; message: string }>()
);

export const getNewVersionFromClipboard = createAction(ActionTypes.GET_NEW_VERSION_FROM_CLIPBOARD, props<{ newVersion: boolean }>());

export const getNewVersionFromClipboardSuccess = createAction(ActionTypes.GET_NEW_VERSION_FROM_CLIPBOARD_SUCCESS, props<{ analysis: Analysis }>());

export const getNewVersionFromClipboardFail = createAction(ActionTypes.GET_NEW_VERSION_FROM_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const pasteFromClipboard = createAction(ActionTypes.PASTE_FROM_CLIPBOARD, props<{ newVersion: boolean }>());

export const pasteFromClipboardSuccess = createAction(ActionTypes.PASTE_FROM_CLIPBOARD_SUCCESS, props<{ analysis: Analysis }>());

export const pasteFromClipboardFail = createAction(ActionTypes.PASTE_FROM_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const getClipboardSuccess = createAction(ActionTypes.GET_CLIPBOARD_SUCCESS, props<{ analysis: Analysis; newVersion: boolean }>());

export const getClipboardFail = createAction(ActionTypes.GET_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const insertFromTemplate = createAction(
    ActionTypes.INSERT_FROM_TEMPLATE,
    props<{ redirectUrl: string; isAbsoluteUrl?: boolean; newVersion: boolean }>()
);

export const openOperatingInstructions = createAction(ActionTypes.OPEN_OPERATING_INSTRUCTIONS);

export const closeOperatingInstructions = createAction(ActionTypes.CLOSE_OPERATING_INSTRUCTIONS);

export const printOperatingInstructionsDocument = createAction(
    ActionTypes.PRINT_OPERATING_INSTRUCTIONS_DOCUMENT,
    props<{ operatingInstructionsDTO: OperatingInstructionsDTO }>()
);

export const printOperatingInstructionsDocumentSuccess = createAction(ActionTypes.PRINT_OPERATING_INSTRUCTIONS_DOCUMENT_SUCCESS, props<{ message: string }>());

export const printOperatingInstructionsDocumentFail = createAction(
    ActionTypes.PRINT_OPERATING_INSTRUCTIONS_DOCUMENT_FAIL,
    props<{ systemError: SystemError }>()
);

export const setTrainingValidation = createAction(ActionTypes.SET_TRAINING_VALIDATION);

export const setTrainingAnalysisValid = createAction(ActionTypes.SET_TRAINING_ANALYSIS_VALID, props<{ analysis: Analysis; message: string }>());

export const setTrainingAnalysisValidSuccess = createAction(ActionTypes.SET_TRAINING_ANALYSIS_VALID_SUCCESS, props<{ analysis: Analysis; message: string }>());

export const setTrainingAnalysisValidFail = createAction(ActionTypes.SET_TRAINING_ANALYSIS_VALID_FAIL, props<{ systemError: SystemError }>());

export const updateAnalysisPartial = createAction(ActionTypes.UPDATE_ANALYSIS_PARTIAL, props<{ changes: Partial<Analysis> }>());

export const updateSingleAnalysisPartial = createAction(ActionTypes.UPDATE_SINGLE_ANALYSIS_PARTIAL, props<{ changes: Partial<SingleAnalysis> }>());

export const updateGroupAnalysisPartial = createAction(ActionTypes.UPDATE_GROUP_ANALYSIS_PARTIAL, props<{ changes: Partial<GroupAnalysis> }>());

export const updateAnalysisPartialAndRecalc = createAction(ActionTypes.UPDATE_ANALYSIS_PARTIAL_RECALC, props<{ changes: Partial<Analysis> }>());

export const updateSingleAnalysisPartialAndRecalc = createAction(
    ActionTypes.UPDATE_SINGLE_ANALYSIS_PARTIAL_RECALC,
    props<{ changes: Partial<SingleAnalysis> }>()
);

export const getAnalysisTypesAndForms = createAction(ActionTypes.GET_ANALYSIS_TYPES_AND_FORMS, props<{ category: AnalysisCategory }>());

export const getAnalysisTypesSuccess = createAction(ActionTypes.GET_ANALYSIS_TYPES_SUCCESS, props<{ analysisTypes: AnalysisType[] }>());

export const getAnalysisFormsSuccess = createAction(ActionTypes.GET_ANALYSIS_FORMS_SUCCESS, props<{ analysisForms: AnalysisForm[] }>());

export const getAnalysisTypesFail = createAction(ActionTypes.GET_ANALYSIS_TYPES_FAIL, props<{ systemError: SystemError }>());

export const getAnalysisFormsFail = createAction(ActionTypes.GET_ANALYSIS_FORMS_FAIL, props<{ systemError: SystemError }>());

export const getFavoritesByUser = createAction(ActionTypes.GET_FAVORITES_BY_USER);

export const getFavoritesByUserSuccess = createAction(ActionTypes.GET_FAVORITES_BY_USER_SUCCESS, props<{ userFavorites: UserFavoriteDTO[] }>());

export const getFavoritesByUserFail = createAction(ActionTypes.GET_FAVORITES_BY_USER_FAIL, props<{ systemError: SystemError }>());

export const addFavoriteUser = createAction(ActionTypes.ADD_FAVORITE_USER, props<{ params: UserFavoriteDTO }>());

export const addFavoriteUserSuccess = createAction(ActionTypes.ADD_FAVORITE_USER_SUCCESS, props<{ favoriteQNumber: string }>());

export const addFavoriteUserFail = createAction(ActionTypes.ADD_FAVORITE_USER_FAIL, props<{ systemError: SystemError }>());

export const removeFavoriteUser = createAction(ActionTypes.REMOVE_FAVORITE_USER, props<{ params: UserFavoriteDTO }>());

export const removeFavoriteUserSuccess = createAction(ActionTypes.REMOVE_FAVORITE_USER_SUCCESS, props<{ favoriteQNumber: string }>());

export const removeFavoriteUserFail = createAction(ActionTypes.REMOVE_FAVORITE_USER_FAIL, props<{ systemError: SystemError }>());

export const searchUser = createAction(ActionTypes.SEARCH_USER, props<{ searchUserParams: UserSimpleSearchParams }>());

export const searchUserSuccess = createAction(ActionTypes.SEARCH_USER_SUCCESS, props<{ users: SearchUser[] }>());

export const searchUserFail = createAction(ActionTypes.SEARCH_USER_FAIL);

export const clearSearchUserParams = createAction(ActionTypes.CLEAR_SEARCH_USER_PARAMS);

export const exitPreviewMode = createAction(ActionTypes.EXIT_PREVIEW_MODE);

export const updateGroupAnalysisElements = createAction(ActionTypes.UPDATE_GROUP_ANALYSIS_ELEMENTS, props<{ groupAnalysisElements: GroupAnalysisElement[] }>());

export const createEmptyAnalysis = createAction(ActionTypes.CREATE_EMPTY_ANALYSIS, props<{ params: { analysisType: AnalysisType } | null }>());

export const createEmptyAnalysisSuccess = createAction(ActionTypes.CREATE_EMPTY_ANALYSIS_SUCCESS, props<{ analysis: Analysis }>());

export const createEmptyAnalysisFail = createAction(ActionTypes.CREATE_EMPTY_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const loadGDMSPopupData = createAction(ActionTypes.LOAD_GDMS_POPUP_DATA);

export const loadGDMSPopupDataSuccess = createAction(ActionTypes.LOAD_GDMS_POPUP_DATA_SUCCESS, props<{ gdmsData: GDMSData }>());

export const loadGDMSPopupDataFail = createAction(ActionTypes.LOAD_GDMS_POPUP_DATA_FAIL, props<{ systemError: SystemError }>());

export const saveAnalysisAndStartGDMSApprovalProcess = createAction(
    ActionTypes.SAVE_ANALYSIS_AND_START_GDMS_APPROVAL_PROCESS,
    props<{ gdmsProcessData: GDMSProcessData }>()
);

export const startGDMSApprovalProcessAfterSave = createAction(ActionTypes.START_GDMS_APPROVAL_PROCESS_AFTER_SAVE, props<{ analysis: Analysis }>());

export const saveAnalysisAndStartGDMSApprovalProcessSuccess = createAction(
    ActionTypes.SAVE_ANALYSIS_AND_START_GDMS_APPROVAL_PROCESS_SUCCESS,
    props<{ analysis: Analysis }>()
);

export const saveAnalysisAndStartGDMSApprovalProcessFail = createAction(
    ActionTypes.SAVE_ANALYSIS_AND_START_GDMS_APPROVAL_PROCESS_FAIL,
    props<{ systemError: SystemError }>()
);

export const stopGDMSProcess = createAction(ActionTypes.STOP_GDMS_PROCESS);

export const stopGDMSProcessSuccess = createAction(ActionTypes.STOP_GDMS_PROCESS_SUCCESS);

export const stopGDMSProcessFail = createAction(ActionTypes.STOP_GDMS_PROCESS_FAIL, props<{ systemError: SystemError }>());

export const loadGDMSDocumentUrl = createAction(ActionTypes.LOAD_GDMS_DOCUMENT_URL);

export const loadGDMSDocumentUrlSuccess = createAction(ActionTypes.LOAD_GDMS_DOCUMENT_URL_SUCCESS, props<{ gdmsDocumentUrl: string }>());

export const loadGDMSDocumentUrlFail = createAction(ActionTypes.LOAD_GDMS_DOCUMENT_URL_FAIL, props<{ systemError: SystemError }>());

export const startConnectAnalysis = createAction(ActionTypes.START_CONNECT_ANALYSIS, props<{ connectedType: string }>());

export const validateNotNullSuccess = createAction(ActionTypes.VALIDATE_NOT_NULL_SUCCESS, props<{ connectedType: string }>());

export const validateNotNullFail = createAction(ActionTypes.VALIDATE_NOT_NULL_FAIL, props<{ systemError: SystemError }>());

export const createGroupAnalysisElements = createAction(
    ActionTypes.CREATE_GROUP_ANALYSIS_ELEMENTS,
    props<{ analysis: Analysis | null; returnUrl: string; connectedType?: string }>()
);

export const createGroupAnalysisElementsSuccess = createAction(
    ActionTypes.CREATE_GROUP_ANALYSIS_ELEMENTS_SUCCESS,
    props<{ analysis: Analysis; returnUrl: string; message: string; connectedType?: string }>()
);

export const createGroupAnalysisElementsFail = createAction(ActionTypes.CREATE_GROUP_ANALYSIS_ELEMENTS_FAIL, props<{ systemError: SystemError }>());

export const updateConnections = createAction(ActionTypes.UPDATE_CONNECTIONS, props<{ analysis: Analysis; returnUrl: string; connectedType?: string }>());

export const updateConnectionsSuccess = createAction(
    ActionTypes.UPDATE_CONNECTIONS_SUCCESS,
    props<{ analysis: Analysis | null; returnUrl: string | undefined; message: string; connectedType?: string }>()
);

export const updateConnectionsFail = createAction(ActionTypes.UPDATE_CONNECTIONS_FAIL, props<{ systemError: SystemError }>());

export const updateSupportAnalysis = createAction(ActionTypes.UPDATE_SUPPORT_ANALYSIS, props<{ supportAnalyses: SupportAba[] }>());

export const isLockedSuccess = createAction(ActionTypes.IS_LOCKED_SUCCESS, props<{ isLocked: boolean; userLockedOut: boolean }>());

export const isLockedFail = createAction(ActionTypes.IS_LOCKED_FAIL, props<{ systemError: SystemError }>());

export const saveLockData = createAction(ActionTypes.SAVE_LOCK_DATA, props<{ lockData: LockDataDTO }>());

export const saveLockDataSuccess = createAction(ActionTypes.SAVE_LOCK_DATA_SUCCESS, props<{ lockData: LockDataResponse }>());

export const saveLockDataFail = createAction(ActionTypes.SAVE_LOCK_DATA_FAIL, props<{ systemError: SystemError }>());

export const loadLockData = createAction(ActionTypes.LOAD_LOCK_DATA);

export const loadLockDataSuccess = createAction(ActionTypes.LOAD_LOCK_DATA_SUCCESS, props<{ lockData: LockDataResponse }>());

export const loadLockDataFail = createAction(ActionTypes.LOAD_LOCK_DATA_FAIL, props<{ systemError: SystemError }>());

export const loadLockCCDCList = createAction(ActionTypes.LOAD_LOCK_CCDC_LIST, props<{ searchParams: SearchParams }>());

export const loadLockCCDCListSuccess = createAction(ActionTypes.LOAD_LOCK_CCDC_LIST_SUCCESS, props<{ ccdcs: PlantCCDC[] }>());

export const loadLockCCDCListFail = createAction(ActionTypes.LOAD_LOCK_CCDC_LIST_FAIL);

export const clearLockCCDCList = createAction(ActionTypes.CLEAR_LOCK_CCDC_LIST);

export const openLockControlPopup = createAction(ActionTypes.OPEN_LOCK_CONTROL_POPUP);

export const resetAnalysisState = createAction(ActionTypes.RESET_ANALYSIS_STATE);

export const generateQRCodePDF = createAction(ActionTypes.GENERATE_QR_CODE_PDF);

export const generateQRCodePDFSuccess = createAction(ActionTypes.GENERATE_QR_CODE_PDF_SUCCESS, props<{ mobileUrl: string }>());

export const generateQRCodePDFFail = createAction(ActionTypes.GENERATE_QR_CODE_PDF_FAIL, props<{ systemError: SystemError }>());

export const resetQRCodePdfUrl = createAction(ActionTypes.RESET_QR_CODE_PDF_URL);

export const loadHeaderDataSearchComponent = createAction(
    ActionTypes.LOAD_SEARCH_COMPONENT,
    props<{ category: AnalysisCategory; searchPlantParams: SearchPlantParams; searchTechnologyParams: SearchTechnologyParams }>()
);

export const deleteAnalysis = createAction(ActionTypes.DELETE_ANALYSIS, props<{ analysisId: number }>());

export const deleteAnalysisSuccess = createAction(ActionTypes.DELETE_ANALYSIS_SUCCESS);

export const deleteAnalysisFail = createAction(ActionTypes.DELETE_ANALYSIS_FAIL, props<{ systemError: SystemError }>());

export const archiveAnalysisManually = createAction(ActionTypes.ARCHIVE_ANALYSIS_MANUALLY);

export const archiveAnalysisManuallySuccess = createAction(ActionTypes.ARCHIVE_ANALYSIS_MANUALLY_SUCCESS, props<{ message: string }>());

export const archiveAnalysisManuallyFail = createAction(ActionTypes.ARCHIVE_ANALYSIS_MANUALLY_FAIL, props<{ systemError: SystemError }>());

export const printPlannedTvgTime = createAction(ActionTypes.PRINT_PLANNED_TVG_TIME);

export const printPlannedTvgTimeSuccess = createAction(ActionTypes.PRINT_PLANNED_TVG_TIME_SUCCESS, props<{ message: string }>());

export const printPlannedTvgTimeFail = createAction(ActionTypes.PRINT_PLANNED_TVG_TIME_FAIL, props<{ systemError: SystemError }>());

export const loadPlannedTvgTimeReport = createAction(ActionTypes.LOAD_PLANNED_TVG_TIME_REPORT);

export const loadPlannedTvgTimeReportSuccess = createAction(ActionTypes.LOAD_PLANNED_TVG_TIME_REPORT_SUCCESS, props<{ report: PlannedTvgTimeReport }>());

export const loadPlannedTvgTimeReportFail = createAction(ActionTypes.LOAD_PLANNED_TVG_TIME_REPORT_FAIL, props<{ systemError: SystemError }>());

export const requestAnalysisVersion = createAction(ActionTypes.REQUEST_ANALYSIS_VERSION, props<{ searchAnalysisParams: SearchAnalysisParams }>());
